import React from "react";

const Treatments = () => {
  return (
    <section id="treatments" className="treatments-section" aria-label="Our Treatments">
      <h2 className="treatments-title">BENEFITS OF HOMOEOPATHY</h2>
      <h2 className="underline">__________________</h2>

      <div className="plant-wrapper">

        {/* 4 Leaves */}
        <div className="leaf-grid">
          <div className="leaf-item-left">Focus on whole person</div>
          <div className="leaf-item-right">Minimal Side Effects</div>
          <div className="leaf-item-left">Natural and gentle approach</div>
          <div className="leaf-item-right">Individualized treatments</div>
        </div>

        {/* Pot Base */}
        <div className="plant-base">
          <div className="base-text-large">Suitable for all age groups</div>
        </div>

        {/* Decorative Lines */}
        <div className="base-line"></div>
        <div className="base-line small"></div>

      </div>
    </section>
  );
};

export default Treatments;
